<template>
  <h1>{{ language[title] }}</h1>
  <div class="container p-0 m-0 my-2 mw-100">
    <div class="d-flex">
      <div class="w-100-sm d-flex">
        <datepicker
          v-model="date"
          range
          multiCalendars="2"
          v-if="enableDate"
          @update:modelValue="getItems()"
        />
        <button
          class="btn mx-3 btn-outline-primary rounded-pill"
          @click="download()"
          v-if="items && items.length > 0"
        >
          <i class="bi bi-download"></i>
        </button>
        <div  v-if="(items && items.length > 0)  && enableDate">
          <div class="align-self-center me-2" v-if="info.value?.loading && info.value?.loading == true">
            <i class="spinner-border ms-1" style="width: 1.75rem; height: 1.75rem"> </i>
          </div>
        </div>
        
      </div>
      <div class="ms-auto" v-if="items && items.length > 0">
        <button
          class="btn rounded-pill me-3"
          v-bind:class="{
            'btn-primary': listType == 'grid',
            'btn-outline-secondary': listType != 'grid',
          }"
          @click="toggleLayout('grid')"
        >
          <i class="bi bi-grid-3x3-gap-fill"></i>
        </button>
        <button
          class="btn rounded-pill me-3"
          v-bind:class="{
            'btn-primary': listType == 'list',
            'btn-outline-secondary': listType != 'list',
          }"
          @click="toggleLayout('list')"
        >
          <i class="bi bi-table"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="
      w-100
      flex-grow-1
      d-flex
      align-items-center
      justify-content-center
      d-block
    "
    v-if="items == null || items.length == 0"
  >
    <p
      class="display-6"
      v-if="
        (items == null || items.length == 0) && info.value?.loading == false
      "
    >
      {{
        info.value?.error
          ? language[info.value.error]
          : language.noRegisterFound
      }}
    </p>
    <div v-if="info.value?.loading && info.value?.loading == true">
      <i class="spinner-border ms-1" style="width: 5rem; height: 5rem"> </i>
    </div>
  </div>

  <component
    :is="currentComponent"
    :items="items"
    :gridLayout="gridLayout"
    :listLayout="listLayout"
  />
</template>

<script>
import { ref, computed } from "vue";
import json from "@/data/data.json";
import gridComponent from "@/components/gridLayout.vue";
import listComponent from "@/components/listLayout.vue";
import Datepicker from "@/components/datePicker.vue";
import useFetch from "@/helpers/api.js";
import downloadCsv from "@/helpers/downloadCsv.js";
import flatten from "@/helpers/flatten.js";
import store from "@/store";

export default {
  props: {
    title: String,
    url: String,
    gridLayout: Object,
    listLayout: Object,
    enableDate: Boolean,
  },
  components: {
    gridComponent,
    listComponent,
    Datepicker,
    downloadCsv,
  },
  data() {
    return {
      listType: "grid",
      items: null,
      date: [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ],
      info: ref({}),
      error: false,
    };
  },
  setup() {
    const language = computed(() => store.getters.getLanguage());
    return {
      language,
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    if (this.enableDate) {
      var start = this.date[0].toISOString();
      var end = this.date[1].toISOString();
      this.fetchData({
        start: start,
        end: end,
      });
    } else {
      this.fetchData("", "");
    }
  },
  mounted() {
    document.title = this.language[this.title];
  },
  methods: {
    toggleLayout(type) {
      this.listType = type;
      json.Departed.map((p) => {
        p.showDetail = false;
        return p;
      });
    },
    async fetchData(date) {
      this.info.value = await useFetch(this.url, date);
    },
    async download() {
      await downloadCsv(this.items, this.title, this.language);
    },
    getItems() {
      try {
        this.error = false;
        this.fetchData({
          start: this.date[0].toISOString(),
          end: this.date[1].toISOString(),
        });
      } catch (error) {
        this.error = true;
        this.items = null;
      }
    },
  },
  computed: {
    currentComponent() {
      return this.listType === "grid" ? "gridComponent" : "listComponent";
    },
  },
  watch: {
    "info.value.loading": function (val) {
      if (val == false) {
        this.items = null;
        if (this.info.value.data?.length > 0) {
          this.items = this.info.value.data.map((d) => {
            d.showDetail = false;
            d.type ? (d.manouverType = d.type) : "";
            if (this.title != "manoeuvreExpected") {
              d.noticeOfArrival.eta = new Date(
                d.noticeOfArrival.eta
              ).toLocaleDateString(["pt-PT"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              });
            }
            const flat = flatten(d);
            return flat;
          });
        }
      }
    },
  },
};
</script>
